// Published CMS routes audited for MAR-83. Explicit aliases; no runtime fuzzy matching.
import type { ShipmentConcept } from "./index"
export const cmsShipmentRoutes: Record<string, ShipmentConcept> = {
  "/pets-v4": "pets",
  "/pets-v4-1": "pets",
  "/sticky-nav-landing": "all",
  "/pets-himv1": "pets",
  "/index-vb": "all",
  "/index-va": "all",
  "/pet-transportation-mnm": "pets",
  "/old-index": "all",
  "/motorcycle-transportation": "motorcycles",
  "/boat-transportation": "boats",
  "/cat-transportation-v2": "cats",
  "/pet-transportation": "pets",
  "/dog-transportation": "dogs",
  "/veteran-moves-discounts": "pets",
  "/military-moves-discounts": "pets",
  "/military-moves": "pets",
  "/dog-transportation-v2": "dogs",
  "/cat-transportation": "cats",
  "/vehicle-transportation": "vehicles",
  "/v4": "all",
}
